function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46906",
    d: "M13 1a12 12 0 1 0 12 12A12 12 0 0 0 13 1zm0 19.2a1.6 1.6 0 1 1 1.6-1.6 1.6 1.6 0 0 1-1.6 1.6zm1.832-12.408-.532 6.416a1.3 1.3 0 0 1-2.592 0l-.536-6.416a1.839 1.839 0 1 1 3.668-.152.968.968 0 0 1-.008.152z",
    style: {
      fill: "#fff"
    },
    transform: "translate(-1 -1)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.32a5dbba44ef82900e43d3f5d29f35da.svg";
export { ForwardRef as ReactComponent };